import { useState } from "react";
import { Edit, Play, Trash } from "iconsax-reactjs";
import Button from "../../commons/Button";
import type { Video } from "../../../services/webServices/video/types";

type VideoCarouselItemProps = {
  video: Video;
  onEdit: (video: Video) => void;
  onDelete: (uuid: string) => void;
};

export default function VideoCarouselItem({ video, onEdit, onDelete }: VideoCarouselItemProps) {

  const [isPlaying, setIsPlaying] = useState(false);

  const handleDelete = () => {
    const confirmed = window.confirm("آیا از حذف این ویدیو مطمئن هستید؟");
    if (!confirmed) return;
    onDelete(video.uuid);
  };

  return (
    <div className="relative w-72 bg-white rounded-2xl shadow-md flex-shrink-0 overflow-hidden">
      <div
        className={`
          absolute top-3 right-3 z-20 flex gap-2 transition-opacity duration-300
          ${isPlaying ? "opacity-0 pointer-events-none" : "opacity-100"}
        `}
      >
        <Button
          variant="neutral"
          style="solid"
          size="md"
          text=""
          loading={false}
          disabled={false}
          onClick={handleDelete}
          icon={Trash}
          customClassName="shadow-[0_0_10px_rgba(0,0,0,0.25)]"
        />

        <Button
          variant="neutral"
          style="solid"
          size="md"
          text=""
          loading={false}
          disabled={false}
          onClick={() => onEdit(video)}
          icon={Edit}
          customClassName="shadow-[0_0_10px_rgba(0,0,0,0.25)]"
        />
      </div>

      <div
        className={`
          group absolute left-1/2 -translate-x-1/2 top-20 z-20 flex items-center justify-center h-10 w-10 rounded-full border border-primaryVar-500 transition-colors hover:border-primaryVar-600
          ${isPlaying ? "opacity-0 pointer-events-none" : "opacity-100"}
        `}
      >
        <button
          type="button"
          title="پلی کردن ویدئو"
          onClick={() => setIsPlaying(true)}
          className="flex items-center justify-center h-8 w-8 rounded-full bg-primaryVar-500 transition-colors group-hover:bg-primaryVar-600"
        >
          <Play size="20" color="#F3F4F6" variant="Bold" className="group-hover:text-gray-200 transition-colors"/>
        </button>
      </div>

      <div className="h-44">
        {!isPlaying ? (
          <img
            src={process.env.REACT_APP_File_URL + video.cover_image}
            alt=""
            className="w-full h-full object-cover"
          />
        ) : (
          <video
            src={process.env.REACT_APP_File_URL + video.content}
            autoPlay
            loop
            playsInline
            onClick={() => setIsPlaying(false)}
            className="w-full h-full object-cover cursor-pointer"
          />
        )}
      </div>

      <div className="h-20 bg-white flex items-start px-2 py-2">
        <h3
          className="
            relative pr-3 line-clamp-2 text-gray-600 font-medium text-base leading-7
            before:absolute before:right-0 before:top-2 before:h-4 before:w-1 before:rounded before:bg-primaryVar-500
          "
        >
          {video.description}
        </h3>
      </div>
    </div>
  );
};